import React from "react";
import Icon1 from "../../common/images/pos_i1.png"
import Icon2 from "../../common/images/pos_i2.png"
import Icon3 from "../../common/images/pos_i3.png"
import Sec_img from "../../common/images/pos_sec_3_img.png"
const IndustriesSection = () => {
  const industries = [
    {
      title: "Restaurants & Cafes",
      description:
        "Handle table orders, split bills, and manage kitchen operations.",
      icon: Icon3,
    },
    {
      title: "E-Commerce",
      description:
        "Sync online and offline sales for unified inventory and reporting.",
      icon: Icon2,
    },
    {
      title: "Airport Parking",
      description:
        "Manage parking reservations, automate payment processing, and monitor availability in real-time.",
      icon: Icon1,
    },
  ];

  return (
    <section className="py-7 px-5 md:px-10 max-w-[1280px] mx-auto text-gray-800">
      <div className="text-center mb-10">
      <h2 className="md:text-5xl text-3xl font-bold">Industries We Serve</h2>
        <div className="underline md:w-1/5 w-2/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-black">
          <p className="h-[5px] rounded-xl bg-primary md:w-[50%] w-[70%]"></p>
        </div>
        <p className="mt-4 text-sm md:text-base">
        Our POS solutions are built to meet the specific needs of various industries:        </p>
      </div>
      <div className="grid md:grid-cols-2 gap-10 items-center">
        <div className="space-y-8">
          {industries.map((industry, index) => (
            <div key={index} className="flex items-center space-x-2">
              <div className=" flex-[0.7]">
                <img src={industry.icon} alt={industry.title} className="size-full" />
              </div>
              <div className="flex-[2]">
                <h3 className="text-xl md:text-2xl font-bold text-[#095C9D]">
                  {industry.title}
                </h3>
                <p className="mt-1 text-sm md:text-base text-black">
                  {industry.description}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-center">
          <img
            src={Sec_img}
            alt="POS Illustration"
            className="max-w-full h-auto"
          />
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
